import Model from 'src/app/common/model';
import CustomerPondModel from './customerPond.model';
import WaterTypeModel from './waterType.model';
import SoilTypeModel from './soilTypeModel';
import PondCultureModel from './pondCulture.model';
import FarmSiteModel from './farmSite.model';
import ClimateParamsModel from './climate-params.model';

export default class ReadingsModel extends Model {
  pond: CustomerPondModel;
  waterType: WaterTypeModel;
  soilType: SoilTypeModel;
  pondCulture: PondCultureModel;
  FarmSiteDetails: Array<FarmSiteModel>;
  climateModel: Array<ClimateParamsModel>;
  temperature?: number;
  pH?: number;
  time?: any;
  tank_id: number;
  farm_site_id?: string;
  person_id?: string;
  water_type_id?: number;
  soil_type_id?: number;
  turbidity?: number;
  do2?: number;
  ammonia?: number;
  conductivity?: number;
  salinity?: number;
  tds?: number;
  comment?: Text;
  cust_added_params?: string;
  nitrite?: number;
  calcium?: number;
  magnesium?: number;
  hardness?: number;
  alkalinity?: number;
  carbonate?: number;
  bicarbonate?: number;
  tan?: number;
  uam?: number;
  ta?: number;
  sg?: number;
  orp?: number;
  tank_number?: string;
  pond_culture_id?: number;
  recommendation: Text;
  isPreparatory: number | string;
  time_interval?: number;
  testType: number | string;
  source_batch_number?: string;
  isBH: boolean;
  process_batch_number?: string;
  production_unit_id?: number;
  shed_id?: number;
  section_id?: number;
  process_id?: number;
  source_batch_alias?: string;
  mating_batch_alias?: string;
  spawning_batch_number?: string;
  lr_batch_number?: string;
  plr_batch_number?: string;
  plr_batch_alias?: string;
  lr_batch_alias?: string;
  spawning_batch_alias?: string;
  process_code?: string;
  filePath: string;
  Nooftests: string;
  section_name: string;
  name: string;
  date: string;
  serial_number: number;
  PreparatoryStage: boolean;
  pondId: number;
  editedReadings: number;
  farm_name: string;
  farmProviderId?: string;
  from_date?: string;
  to_date?: string;
  feedProviderId?: string;
  fromDate: string;
  toDate: string;
  ph: boolean;
  do: boolean;
  Tan: boolean;
  Salinity: boolean;
  temp: boolean;
  uammonia: boolean;
  custNitrite: boolean;
  custalkalinity: boolean;
  biofloc: boolean;
  Orp: boolean;
  Tds: boolean;
  Turbidity: boolean;
  Carbonate: boolean;
  bicorbonate: boolean;
  custhardness: boolean;
  custcalcium: boolean;
  magnisium: boolean;
  all: boolean;
  business_id: string;
  businessName: string;
  farmNameAtLocation: string;

 constructor() {
    super();
    this.FarmSiteDetails = new Array();
    this.climateModel = new Array();
  }
}

